<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.5 8.125L6.5 4.125"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.5 13.3257V6.92434C17.4997 6.64371 17.4225 6.36808 17.2763 6.12511C17.13 5.88214 16.9198 5.68038 16.6667 5.54006L10.8333 2.3394C10.58 2.19895 10.2926 2.125 10 2.125C9.70744 2.125 9.42003 2.19895 9.16667 2.3394L3.33333 5.54006C3.08022 5.68038 2.86998 5.88214 2.72372 6.12511C2.57745 6.36808 2.5003 6.64371 2.5 6.92434V13.3257C2.5003 13.6063 2.57745 13.8819 2.72372 14.1249C2.86998 14.3679 3.08022 14.5696 3.33333 14.7099L9.16667 17.9106C9.42003 18.0511 9.70744 18.125 10 18.125C10.2926 18.125 10.58 18.0511 10.8333 17.9106L16.6667 14.7099C16.9198 14.5696 17.13 14.3679 17.2763 14.1249C17.4225 13.8819 17.4997 13.6063 17.5 13.3257Z"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.5 6.41113L10 10.6968L17.5 6.41113"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10 18.1968V10.6968"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
